import React, { FC, ReactNode } from "react";
import { Tooltip as MaterialTooltip } from "@mui/material";

import "./Tooltip.scss";
import { ReferenceType } from "modules/documents/data/enum/reference-type.enum";

type TooltipProps = {
  id?: string;
  allowClick?: boolean;
  allowHover?: boolean;
  flip?: boolean;
  placement?: "top" | "right" | "bottom" | "left";
  text?: string;
  variant?: "default" | "alt";
  hide?: boolean;
  children: any;
  content?: ReactNode;
  contentClassName?: string;
  hideCloseButton?: boolean;
  hideArrow?: boolean;
  className?: string;
  score?: number; //
  isFromContext?: boolean;
  showSource?: boolean;
  referenceType?: string;
};

function getConfidenceLabel(score?: number): string {
  if (typeof score !== "number") return "";
  if (score > 90) return "High";
  if (score > 80) return "Medium";
  if (score >= 70) return "Low";
  return "";
}

const Tooltip: FC<TooltipProps> = ({
  id = "tooltip",
  allowClick = false,
  allowHover = true,
  children,
  flip = true,
  placement = "top",
  text,
  score,
  variant = "alt",
  hide = false,
  content,
  contentClassName = "",
  hideCloseButton = false,
  hideArrow = false,
  isFromContext,
  showSource = true,
  className = "",
  referenceType
}: TooltipProps) => (
  <MaterialTooltip
    id={id}
    placement={placement}
    className={contentClassName}
    arrow={true}
    disableHoverListener={hide}
    title={
      <div className={"tooltip-container " + className}>
        <div className="tooltip-content">{text ? text : content}</div>
        {showSource && (
          <div className="tooltip-item">
            <span className="tooltip-item__title">Source:</span>
            <span className="tooltip-item__description">
              {isFromContext ? " Context" : " Requirement"}
            </span>
          </div>
        )}
        {typeof score === "number" ? (
          <div className="tooltip-item">
            <span className="tooltip-item__title">Confidence Score:</span>
            <span
              className="tooltip-item__badge"
              style={{ marginLeft: 8, fontWeight: "bold" }}
            >
              {getConfidenceLabel(score)}
            </span>
          </div>
        ) : null}
      </div>
    }
    slotProps={{
      popper: {
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [120, 8]
            }
          }
        ]
      }
    }}
  >
    {children}
  </MaterialTooltip>
);

export default Tooltip;
